/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 用户服务接口
 */

import xhr from './xhr/index'
import { BaseParams } from '@/services/index'

interface ILoginParams {
    username: string   // 用户名 
    password: string   // 密码 
}

interface IGetUserInfoParams {
    id: string   // 用户 ID
}

interface IUpdateUserInfoParams {
    name?: string,                    // 姓名（2~10个字）
    avatar?: string,                  // 头像图片名字
    eamil?: string,                   // 邮箱
    email_notice?: boolean,           // 邮件通知 true:开启 false:关闭
    type?: number,                     // 身份, 0:媒体人, 1:品牌方/政务人士, 2:专家学者, 3:其他
    intro?: string,                   // 个人简介（5-50个字）
    profession?: string,              // 职业名（2~10个字）
    company?: string,                 // 公司/单位名（2~20个字）
}

interface IRefreshTokenParams {
    token: string   // 令牌 token
}

interface IGetNmUsersParams {
    name?: string
    mobile?: string
    company?: string
    identity?: number           // 身份
    cert_status?: number        // 认证状态
    register_platform?: number | string  // 注册平台
    page_index?: number         // 第几页
    page_size?: number          // 每页条数
    created_at_gte?: string     // (n)注册时间大于等于多少
    created_at_lte?: string     // (n)注册时间小于等于多少
}

interface  IGetNmUserParams {
    id: string   // 用户 ID
}

interface IUpdateNmUserParams {
    user_id: string           // 用户 ID
    cert_status?: number      // 认证状态
    reporter_id?: number      // 关联的记者 ID
    memo?: string,            // 备注(1000字以内)
    is_contacted?: boolean    // 是否已联系
    pr_company_id?: number
}

interface IGetNmUserSLogsParams extends BaseParams {
    user_id?: string          // 用户 ID
}

interface IGetUsersParams extends BaseParams {
    name?: string           // 姓名模糊搜索
    department?: string     // 部门模糊搜索
    role?: number           // 账号类型
    mobile?: string         // 手机号模糊搜索
    email?: string          // 邮箱模糊搜索
}

interface ICreateUserParams {
}

interface IUpdateUserParams {}

interface ICancelMyAccountParams {
    id: string   // 当前登录用户 ID
    role: number // 固定传 -1, 停用账户(注销, 软删除)
}

interface IBlockNmUserParams {
    id: string               // 用户 ID
}

interface IUnBlockNmUserParams {
    id: string               // 用户 ID
}

interface ISendMesaageToUserParams {
    user_id: string         // 牛媒用户id
    content: string         // 发送的内容 (字数:10-66)
    type: string[]          // 指定发送的类型,可多选 sms:短信;im:聊天消息;默认都发送 
}

interface IGetPhoneApplyParams extends BaseParams {
    status?: number         // 0:全部(默认) 1:审核中 2:通过 3:不通过
}

interface ICreatePhoneApplyParams {
    nm_user_id: string      // 牛媒用户id
}

interface IUpdatePhoneApplyStatusParams {
    id: number
    status: number
}

interface IUpdateUserLevelParams {
    user_id: string
    vip_level: number
}

interface IGetDeleteNewApplyListParams {
    status: string
    page_index: number
    page_size: number
}

interface IGetDeleteNewApplyParams {
    news_id: number
}

interface IPutDeleteNewApplyParams {
    id: number
    status: string
}

interface IPostDeleteNewApplyParams {
    news_id: number
    status: string
}

class UserService {
    /** 登录 */
    public async login(params: ILoginParams) {
        const result = await xhr({
            method: 'post',
            url: '/user/login',
            params: params 
        })
        return result
    } 
    /** 获取用户信息 */
    public async getUserInfo(params: IGetUserInfoParams) {
        const result = await xhr({
            method: 'get',
            url: '/user',
            params: params 
        })
        return result
    }
    /** 获取用户列表 */
    public async getUsers(params: IGetUsersParams) {
        const result = await xhr({
            method: 'get',
            url: '/user/list',
            params: params 
        })
        return result
    }
    /** 创建用户 */
    public async createUser(params: ICreateUserParams) {
        const result = await xhr({
            method: 'post',
            url: '/user',
            params: params 
        })
        return result
    }
    /** 修改用户信息 */
    public async updateUser(params: IUpdateUserParams) {
        const result = await xhr({
            method: 'put',
            url: '/user',
            params: params 
        })
        return result
    }
    /** 注销当前登录账号(将自身 role 置为 -1, 停用账户, 软删除) */
    public async cancelMyAccount(params: ICancelMyAccountParams) {
        const result = await xhr({
            method: 'put',
            url: '/user',
            params: params 
        })
        return result
    }
    /** 获取用户信息 */
    public async refreshToken(params: IRefreshTokenParams) {
        const result = await xhr({
            method: 'put',
            url: '/user/refresh_token',
            params: params 
        })
        return result
    }
    /** 获取牛媒用户列表 */
    public async getNmUsers(params: IGetNmUsersParams) {
        const result = await xhr({
            method: 'get',
            url: '/nm_user/list',
            params: params 
        })
        return result
    }
    /** 获取牛媒用户 */
    public async getNmUser(params: IGetNmUserParams) {
        const result = await xhr({
            method: 'get',
            url: '/nm_user',
            params: params 
        })
        return result
    }
    /** 修改牛媒用户信息 */
    public async updateNmUser(params: IUpdateNmUserParams) {
        const result = await xhr({
            method: 'put',
            url: '/nm_user',
            params: params 
        })
        return result
    }
    /** 获取牛媒用户搜索日志 */
    public async getNmUserSLogs(params: IGetNmUserSLogsParams) {
        const result = await xhr({
            method: 'get',
            url: '/nm_user/search_logs',
            params: params 
        })
        return result
    }
    /** 牛媒用户封号 */
    public async blockNmUser(params: IBlockNmUserParams) {
        const result = await xhr({
            method: 'put',
            url: '/nm_user/disable',
            params: params 
        })
        return result
    }
    /** 牛媒用户解禁 */
    public async unBlockNmUser(params: IUnBlockNmUserParams) {
        const result = await xhr({
            method: 'put',
            url: '/nm_user/enable',
            params: params 
        })
        return result
    }
    /** 给用户发送短信和消息 */
    public async sendMesaageToUser(params: ISendMesaageToUserParams) {
        const result = await xhr({
            method: 'post',
            url: '/nm_user/contact',
            params: params
        })
        return result
    }

    /** 获取手机号查看申请列表 */ 
    public async getPhoneApplyList(params: IGetPhoneApplyParams) {
        const result = await xhr({
            method: 'get',
            url: '/user/look_mobile/list',
            params: params
        })
        return result
    }

    /** 新建手机号查看记录 */ 
    public async createPhoneApply(params: ICreatePhoneApplyParams) {
        const result = await xhr({
            method: 'post',
            url: '/user/look_mobile',
            params: params
        })
        return result
    }

    /** 更新手机号查看记录状态 */ 
    public async updatePhoneApply(params: IUpdatePhoneApplyStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/user/look_mobile',
            params: params
        })
        return result
    }

    /** 更新用户 vip 等级 */
    public async updateUserLevel(params: IUpdateUserLevelParams) {
        const result = await xhr({
            method: 'put',
            url: '/nm_user/vip',
            params: params
        })
        return result
    }
    
    /** 访问统计 */
    public async getAccessStat(params: any) {
        return xhr({
            method: 'get',
            url: '/nm_user/access_stat',
            params: params
        })
    }

    public async getDeleteNewApplyList(params: IGetDeleteNewApplyListParams) {
        return xhr({
            method: 'get',
            url: '/user/news_delete_apply/list',
            params: params
        })
    }

    public async getDeleteNewApply(params: IGetDeleteNewApplyParams) {
        return xhr({
            method: 'get',
            url: '/user/news_delete_apply',
            params: params
        })
    }

    public async putDeleteNewApply(params: IPutDeleteNewApplyParams) {
        return xhr ({
            method: 'put',
            url: '/user/news_delete_apply',
            params: params
        })
    }

    public async postDeleteNewApply(params: IPostDeleteNewApplyParams) {
        return xhr({
            method: 'post',
            url: '/user/news_delete_apply',
            params: params
        })
    }
}

// 实例化后导出，全局单例
export default new UserService()
